export const headerTemplate = (
  landingPageData,
  course,
  collection,
  pageUrl,
) => {
  if (landingPageData) {
    // For the start button section, we need to convert the JSX to a string
    let startButtonHtml = ''
    if (pageUrl === 'mini-course') {
      startButtonHtml = `
        <div class="start-button-container-header">
          <div class="start-button-header">
            <div
              class="start-button-text-header"
              style="color: ${
                landingPageData.primaryColor || '#000000'
              } !important; font-family: ${
        landingPageData.font || 'Inter'
      } !important"
            >
              ${
                landingPageData.localizations
                  ? landingPageData.localizations.startButton
                  : 'START COURSE'
              }
            </div>
          </div>
        </div>
      `
    }

    // Force refresh the logo URL on each render by adding a timestamp or random value
    // This prevents caching of the previous logo URL
    const timestamp = new Date().getTime()

    // Check if logo URL already has https prefix
    const logoUrl = landingPageData.logo
      ? landingPageData.logo.startsWith('https')
        ? `${landingPageData.logo}?t=${timestamp}`
        : `https://cdn.minicoursegenerator.com/${landingPageData.logo}?t=${timestamp}`
      : ''

    return `
      <div class="editor-header-img-container">
          ${
            landingPageData.logo
              ? `<img 
               src="${logoUrl}" 
               class="header-logo" 
               alt="logo" 
             />`
              : ''
          }
      </div>
    
      <div class="course-container-header-text" style="font-family: ${
        landingPageData.font || 'Inter'
      } !important">${
      pageUrl === 'mini-course'
        ? course
          ? course.name
          : ''
        : collection
        ? collection?.name
        : ''
    }</div>

      ${startButtonHtml}
    `
  }
  return ''
}
